import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import NumberField from '../fields/NumberField';
import Constants from '../../utils/Constants';
import { priceValidator } from '../../validators/price';
import { quantityValidator } from '../../validators/quantity';
import { auctionType } from '../../types';
import './_styles_/BidsInputParamConfigurationForm.css';
import {
    getBiddingType,
    OPEN,
} from '../../utils/BiddingTypes';
import WarningPanel from '../WarningPanel';
import useSingleValidator from '../../hooks/useSingleValidator';

BidsInputParamConfigurationForm.propTypes = {
    auction: auctionType.isRequired,
    onQuantityStepChange: PropTypes.func.isRequired,
    onPriceStepChange: PropTypes.func.isRequired,
    onQuantityStepValidation: PropTypes.func.isRequired,
    onPriceStepValidation: PropTypes.func.isRequired,
    priceStep: PropTypes.number.isRequired,
    isConflictWithBiddingUserConfigurationQuantityStep: PropTypes.bool.isRequired,
    isConflictWithBiddingUserConfigurationPriceStep: PropTypes.bool.isRequired,
    quantityStep: PropTypes.number,
};

function BidsInputParamConfigurationForm(props) {
    const {
        auction,
        onQuantityStepChange,
        onPriceStepChange,
        onQuantityStepValidation,
        onPriceStepValidation,
        quantityStep = null,
        priceStep,
        isConflictWithBiddingUserConfigurationQuantityStep,
        isConflictWithBiddingUserConfigurationPriceStep,
    } = props;
    const { t } = useTranslation();
    const biddingType = getBiddingType(auction.biddingType);
    const { validator: quantityStepValidator } = useSingleValidator(true, useMemo(() => quantityValidator(t, auction.smallestUnit, auction.maxBidSize || auction.quantity), [t, auction.smallestUnit, auction.maxBidSize, auction.quantity]));
    const { validator: priceStepValidator } = useSingleValidator(true, useMemo(() => priceValidator(t, Constants.MIN_PRICE_STEP, auction.maxPrice), [t, auction.maxPrice]));
    return (
        <div className="auction-bids--place-bid--configuration--container">
            <div className="auction-bids--place-bid--configuration--input-parameters">
                {biddingType.is(OPEN) && (
                    <NumberField
                        className="auction-bids--place-bid--configuration--input-parameters--quantity-step"
                        label={t('auctions.bids-list.quantity-step')}
                        value={quantityStep}
                        validator={quantityStepValidator}
                        onValidated={onQuantityStepValidation}
                        onChange={onQuantityStepChange}
                        step={auction.smallestUnit}
                    />
                )}
                <NumberField
                    className="auction-bids--place-bid--configuration--input-parameters--price-step"
                    label={t('auctions.bids-list.price-step')}
                    value={priceStep}
                    validator={priceStepValidator}
                    onValidated={onPriceStepValidation}
                    onChange={onPriceStepChange}
                    step={Constants.MIN_PRICE_STEP}
                />
            </div>
            {(isConflictWithBiddingUserConfigurationQuantityStep || isConflictWithBiddingUserConfigurationPriceStep) && (
                <div className="auction-bids--place-bid--configuration--warning-box">
                    {isConflictWithBiddingUserConfigurationQuantityStep && (
                        <WarningPanel message={t('auctions.bids-list.user-configuration-conflict-with-quantity-step')} />
                    )}
                    {isConflictWithBiddingUserConfigurationPriceStep && (
                        <WarningPanel message={t('auctions.bids-list.user-configuration-conflict-with-price-step')} />
                    )}
                </div>
            )}
        </div>
    );
}

export default BidsInputParamConfigurationForm;
